import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

export interface AssignedDomain {
  id: number;
  hostname: string;
  brandName: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
  role: 'admin' | 'domain_admin' | 'merchant';
  languagePreference: 'en' | 'de' | 'es' | 'it';
  assignedDomains?: AssignedDomain[];
  createdAt: string;
  updatedAt: string;
}

export interface UserDto {
  name: string;
  email: string;
  role: 'admin' | 'domain_admin' | 'merchant';
  languagePreference: 'en' | 'de' | 'es' | 'it';
  domainConfigIds?: number[];
}

export async function getAllUsers(): Promise<User[]> {
  const response = await axiosInstance.get(`${baseUrl}/admin/users`);
  return response.data;
}

export async function getUserById(id: number): Promise<User> {
  const response = await axiosInstance.get(`${baseUrl}/admin/users/${id}`);
  return response.data;
}

export async function createUser(userData: UserDto): Promise<User> {
  const response = await axiosInstance.post(`${baseUrl}/admin/users`, userData);
  return response.data;
}

export async function updateUser(id: number, userData: UserDto): Promise<User> {
  const response = await axiosInstance.put(`${baseUrl}/admin/users/${id}`, userData);
  return response.data;
}

export async function deleteUser(id: number): Promise<void> {
  await axiosInstance.delete(`${baseUrl}/admin/users/${id}`);
}
